import * as HEALTH_TYPES from './types';

export const getPayProStatus = () => ({
    type: HEALTH_TYPES.PAY_PRO_STATUS_GET,
});

export const setPayProStatus = ({ status }) => ({
    type: HEALTH_TYPES.PAY_PRO_STATUS_SET,
    payload: { status },
});
